<script>
export default {
  name: "formSwitch",
  components: {},
  props: {
    //值
    value: {
      type: Boolean,
      default: false
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //开关尺寸
    size: {
      type: [String, Number],
      default: "22"
    }
  },
  data() {
    return {
      realValue: false
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {
    this.realValue = this.value;
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    fieldRender() {
      let { title, required } = this;
      let option = {
        props: {
          center: true,
          title,
          required
        },
        scopedSlots: {
          "right-icon": () => this.switchRender()
        }
      };
      return <van-cell {...option} />;
    },
    switchRender() {
      let { readonly, disabled, realValue: value, size } = this;
      disabled = readonly || disabled;
      let option = {
        props: {
          size,
          disabled,
          value
        },
        on: {
          input: e => {
            this.realValue = e;
            this.$emit("change", e);
          }
        },
        ref: "input"
      };
      return <van-switch {...option} />;
    }
  },
  render() {
    return this.fieldRender();
  }
};
</script>

<style lang="less" scoped></style>
